import React from 'react'
import { Link } from 'react-router-dom';







export default function Header() {
  return (
    <>
        
   
        <header className="header_area">
        <nav className="navbar navbar-expand-lg">
            <div className="container">
              <Link className="navbar-brand" to="/"><img src="https://issuewireassets.s3-us-west-2.amazonaws.com/assets/images/web-logo02.png" title="" alt="" /></Link>
              {/* <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <i className="fa-solid fa-bars"></i>
              </button>
              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav ml-auto">
                  <li className="nav-item">
                    <Link className="nav-link active" aria-current="page" to="#">Home</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="#">Podcasts</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="#">Blog</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="#">Contact</Link>
                  </li>
                </ul>
              </div> */}
            </div>
          </nav>
    </header>
    
    
    </>
  )
}
